import React from "react";
import { InlineMath } from "react-katex";
import PiInput, { formatPiValueLatex, parsePiLikeInput } from "../../../components/inputs/PiInput";

export const range = (a, b) => Array.from({ length: b - a + 1 }, (_, i) => a + i);
export const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function checkPiAnswer(expectedNumeric, userAnswer) {
  if (!userAnswer) return false;
  const parsed = Number.isFinite(userAnswer?.parsed)
    ? userAnswer.parsed
    : parsePiLikeInput(userAnswer?.raw);
  if (!Number.isFinite(parsed)) return false;

  const usedPi = /pi|π/i.test(String(userAnswer?.raw || ""));
  const eps = usedPi ? 1e-6 : 0.0100001;
  return Math.abs(parsed - expectedNumeric) <= eps;
}

export function SolidPiInput({ value, onChange, disabled, label, placeholder }) {
  return (
    <PiInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      label={label}
      placeholder={placeholder || "np. 24π, 15*pi, 75,40"}
    />
  );
}

export function renderPiUserAnswer(userAnswer, label) {
  const raw = userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  const latex = formatPiValueLatex(raw) || String(raw);
  return <InlineMath math={`\\displaystyle ${label}=${latex}`} />;
}

export function renderPiAnswer(label, k) {
  return <InlineMath math={`${label}=${k}\\pi`} />;
}
